 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		25: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"npm.quill","2":"npm.react-dom","3":"npm.react-quill","7":"npm.babel","8":"npm.emoji-picker-react","9":"npm.react-dd-menu","10":"npm.react-papaparse","11":"npm.react-player","12":"npm.readable-stream","17":"npm.canvg","18":"npm.create-react-class","19":"npm.d3-scale","20":"npm.dompurify","21":"npm.react-querybuilder","22":"npm.react-smooth","23":"npm.react-sortable-hoc","24":"npm.recharts"}[chunkId]||chunkId) + "." + {"1":"d603068026ac191700d3","2":"0e7c69ea3084e053b6a2","3":"178c407a689716bef2cb","4":"bd6e356416e16e6e78b4","5":"0752386db0b151ca1594","6":"b60353fe52070d422928","7":"f53aa471d5fd48bd2f25","8":"60e8a3c3d4500ffdf1b4","9":"091a8b7bab5aa73ee718","10":"c474607377a9ed04d054","11":"f51a5adafe29531e67fc","12":"ca130e96103a05dd5f36","13":"54d1ce6bcb6b04d54b9b","14":"1b625f3378a9db60bbef","17":"23abe43bec6ee4a4ccb2","18":"4d17f9c1570e999f6e9d","19":"f35c3202dd6e26f0654c","20":"01f21c1fa07c5237801c","21":"5958492da9d50145e70e","22":"8bdea132b417f5b65922","23":"3176a1410e1709acb014","24":"608993608670a53be41c","26":"ddaec639721eac38fb9a","27":"ad9d335663817b9e5e12","28":"f5b909950d2697e939e9","29":"eb189d493eec3a33672d","30":"48cf34ad8e4a421e54a6","31":"5e89fb0555d8a42a6cb7","32":"6a5848880097661b4207","33":"61276a2c2bc60b948339","34":"d89cd0b9bab5daa4b434","35":"04453664f50ef43b0202","36":"c9967d1638053d1ab89f","37":"4ed32f2b75b3d9948124","38":"6bcfedb0fbaa6bb07e81","39":"b212c5c6ff4b6e95e0ef","40":"16e89f99f088ec93f646","41":"3f6caba806e7ad7fb265","42":"fcc3b359a658ba21fcfe","43":"4d14af04528f48892e1e","44":"7875842dfa427c9505b5","45":"40f8db66aae2e8972743","46":"305959a0483f032cebeb","47":"c5d566e45771840f42ad","48":"e61b221d0c80d0e5a190","49":"aa92ef8ef06246c524fa","50":"fc5534a2dc27ecd9ade0","51":"0a324171f72029a49a8f","52":"ee28a6a8f8b57879cdd6","53":"043446833431fd924bc4","54":"34e5d6b2bf0ebbae9f1f","55":"c93d40e933b5a2f5ef56","56":"9e438361326090dfa5ff","57":"e9bf633ade094888d3d4","58":"407d74790bde57939f56","59":"5c3cc389b8c465bab20b","60":"d1afb86bc7195d55c295","61":"52ff6a5714121dc13b3b","62":"d060e687403f8b3643e6","63":"6437859fa5b46e9519b3","64":"13ee7db95cd5c8fb2a20","65":"66aa9d9b092d82358155","66":"bb2562c2a236a5c5c2e0","67":"5eab31919026fb70a607","68":"9f9ce71232ac03ac0267","69":"2739f6e6051514d54bbd","70":"0f3f52d7f88cfc5a35b3","71":"b00b94fbcadc7a529045","72":"9c3cbf454a8886920c66","73":"031aeb47afbd29e56c45","74":"9fac8873bd8c4ab2ab43","75":"5d59cc8127143523066c","76":"52700f2d34412fe2f922","77":"56877d69e99c92818ad4","78":"8d8b4861f1d61e4a4d54","79":"84b8b249ea9838b8062c","80":"18de11e59da89e8edbd9","81":"04f2252f0ffbd7a0c000","82":"8a2a4d3465f7fb0411ba","83":"f1430669a932145fdc5c","84":"b7a53cda5164e02bfda8","85":"2608c1906bb98ebd4b14","86":"d0214f6409d111cd7dc8","87":"43dd2ba69f1249b42977","88":"0fc151bc81b9ec311cfd","89":"392a5848e180d9941631","90":"c54d87ee76dc4316a9be","91":"b98d474a00e2ab0e48d3","92":"d59466bd09d8aa99cd5b"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/79507b6/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
